
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

interface InviteSuccessDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  type: 'email' | 'wallet'
}

export function InviteSuccessDialog({
  open,
  onOpenChange,
  count,
  type,
}: InviteSuccessDialogProps) {
  const handleContinue = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {type === 'email' ? 'Invite via Email' : 'Invite via Wallet'}
          </DialogTitle>
          <DialogDescription className="sr-only">Invitation sent successfully</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4 items-center">
          {/* Success Message */}
          <div className="w-full bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded-2xl py-4 flex flex-col items-center gap-4">
            <Icon name="check" className="h-6 w-6 text-green-600" />
            <p className="text-sm font-medium text-foreground text-center">
              {count} invite{count !== 1 ? 's' : ''} send successfully
            </p>
          </div>

          {/* Action Button */}
          <Button size="lg" onClick={handleContinue} className="self-end">
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
